/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGOpenCode3(props) {
  return (
    <svg width={58} height={70} viewBox="0 0 58 70" {...props}>
      <g>
        <path
          d="M37.898 1h-34.888c-1.11 0-2.01.899-2.01 1.992v63.183c0 1.1.892 1.992 2.003 1.992h51.342c1.106 0 2.003-.89 2.003-2.006v-46.843l-18.449-18.318z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M48.914 11.938l7.433 7.381v46.843c0 1.116-.897 2.006-2.003 2.006h-51.342c-1.111 0-2.003-.892-2.003-1.992v-4.114h45.657c1.106 0 2.007-.899 2.013-1.992l.244-48.132z"
          id="Combined-Shape"
          fill="#CBECF9"
        />
        <path
          d="M56.347 19.318h-16.439c-1.11 0-2.009-.896-2.009-1.995v-16.323"
          fill="#97D9F2"
        />
        <path
          d="M21.399 33.243l-7.758 2.762 7.758 2.742v2.413l-10.315-4.021v-2.287l10.315-4.031v2.422zm5.153 6.231h2.606v2.742h-2.606v-2.742zm2.606-1.143h-2.606v-1.492c0-.64.101-1.185.303-1.638.202-.452.563-.93 1.083-1.434l.878-.862c.41-.394.688-.72.834-.979.146-.258.22-.526.22-.804 0-.433-.15-.759-.449-.979-.299-.22-.748-.329-1.347-.329-.547 0-1.117.115-1.713.344-.595.229-1.205.57-1.83 1.022v-2.597c.638-.362 1.283-.635 1.937-.819.654-.184 1.309-.276 1.966-.276 1.314 0 2.345.304 3.094.911.748.607 1.122 1.444 1.122 2.51 0 .491-.111.948-.332 1.371-.221.423-.638.932-1.249 1.526l-.859.833c-.442.426-.725.775-.849 1.047-.124.271-.185.604-.185.998l-.005.203-.015.252v1.192zm5.992-5.087v-2.422l10.315 4.031v2.287l-10.315 4.021v-2.413l7.758-2.742-7.758-2.762z"
          fill="#97D9F2"
        />
        <path
          d="M38.31 0l19.037 18.902v47.259c0 1.666-1.342 3.006-3.003 3.006h-51.342c-1.661 0-3.003-1.337-3.003-2.992v-63.183c0-1.649 1.351-2.992 3.01-2.992h35.3zm-35.3 2c-.557 0-1.01.45-1.01.992v63.183c0 .549.445.992 1.003.992h51.342c.557 0 1.003-.445 1.003-1.006v-46.427l-17.861-17.735h-34.476zm53.337 16.318v2h-16.439c-1.66 0-3.009-1.341-3.009-2.995v-16.323h2v16.323c0 .547.451.995 1.009.995h16.439z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGOpenCode3.js